import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { app } from "../../../../Features/config/firebase";

export async function uploadBanner(
  image: File
): Promise<{ url: string; uniqueId: string }> {
  return new Promise<{ url: string; uniqueId: string }>((resolve, reject) => {
    // Get a reference to the storage service, specifying the bucket
    const storage = getStorage(app, "gs://platforms-tech.appspot.com");

    // Create a storage reference
    const storageRef = ref(storage);
    const uniqueId = Math.random().toString(36).substr(2, 9);

    // Create a unique file name
    uploadBytes(
      ref(storageRef, "/channel-banners/" + image.name + uniqueId),
      image
    )
      .then(function (snapshot) {
        // console.log("Uploaded", snapshot.metadata.size, "bytes.");
        // console.log("File metadata:", snapshot.metadata);
        // Let's get a download URL for the file.
        getDownloadURL(snapshot.ref).then(function (url) {
          console.log("File available at", url);
          return resolve({ url, uniqueId });
        });
      })
      .catch(function (error) {
        console.error("Upload failed:", error);
        return reject(error);
      });
  });
}

export async function uploadDefaultBanner(
  image: File,
  channelId: string
): Promise<{ url: string }> {
  return new Promise<{ url: string }>((resolve, reject) => {
    // Get a reference to the storage service, specifying the bucket
    const storage = getStorage(app, "gs://platforms-tech.appspot.com");

    // Create a storage reference
    const storageRef = ref(storage);

    // Create a unique file name
    uploadBytes(
      ref(storageRef, "/channel-banner-defaults/" + channelId + "default"),
      image
    )
      .then(function (snapshot) {
        // Let's get a download URL for the file.
        getDownloadURL(snapshot.ref).then(function (url) {
          console.log("File available at", url);
          return resolve({ url });
        });
      })
      .catch(function (error) {
        console.error("Upload failed:", error);
        return reject(error);
      });
  });
}
